// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2OeLT","rightAdornment":"Header_rightAdornment__cM_2N"};